export const COPY_BLOCK = 'copy-block';
export const CUT_BLOCK = 'cut-block';
export const PASTE_BLOCK = 'paste-block';
export const PASTE_BEFORE_THIS_BLOCK = 'paste-before-this-block';
export const PASTE_AFTER_THIS_BLOCK = 'paste-after-this-block';
export const HIDE_BLOCK_ON = 'hide-block-on';
export const WIDGET_HIDE_ON = 'widget-hide-on';
